// extracted by css-extract-rspack-plugin
export default {"measuring":"SidebarPopup-module__measuring___jywUl"};